/**
 * Requests Query Policy (Solicitudes tab — TV1-2377 slice 7)
 *
 * Loads the seller's Sub-Goal rows from `/automation-requests` — the org-scoped
 * seller route on the Automation Requests readmodel (Sub-Goal grain, P6). One
 * read serves BOTH the list (grouped by request in `selectors.requestSummaries`)
 * and the detail (filtered by `requestId`), so navigating into a request does not
 * re-fetch.
 *
 * ⚠️ These rows are NOT rules and are never merged into the Reglas catalog: under
 * D1 no rule exists until a human approves, and an unsatisfiable Sub-Goal never
 * becomes one.
 */

import { Policy } from '@commandDrivenStateEngine/core/policies';
import { ClientLibraryType } from '@bett3r-dev/teselly-client-library';
import { RequestsState } from '../state';
import { RequestsCommand } from '../commands';

export const createRequestsQueryPolicy = (
  backend: ClientLibraryType
): Policy<RequestsState, RequestsCommand> => {
  let closed = false;

  return {
    name: 'automation-requests-query',

    init: ({ dispatch }) => {
      ( async () => {
        dispatch(
          { type: 'automation/requests/loading/setListLoading', payload: { isLoading: true }},
          { source: 'api' }
        );
        try {
          const subGoals = await backend.queries.AutomationRequests();
          if ( closed ) return;
          dispatch(
            { type: 'automation/requests/data/setSubGoals', payload: { subGoals: subGoals || []}},
            { source: 'api' }
          );
        } finally {
          if ( !closed ) {
            dispatch(
              { type: 'automation/requests/loading/setListLoading', payload: { isLoading: false }},
              { source: 'api' }
            );
          }
        }
      })();

      return () => {
        closed = true;
      };
    }
  };
};
